import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

export default function ControllerContainer({ error, label, children, id }) {
  return (
    <FormControl variant="standard" fullWidth error={error} aria-label={`${id}-label`}>
      {!label || label === '' ? null : (
        <InputLabel shrink htmlFor={id} sx={{ fontSize: '16px' }}>
          {label}
        </InputLabel>
      )}

      {children}
    </FormControl>
  );
}
